import React, {useState} from "react";
import useStyles from "../styles";
import TextField from "@material-ui/core/TextField";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import uaLocale from 'date-fns/locale/uk';
import DateFnsUtils from "@date-io/date-fns";
import {
    Checkbox,
    CircularProgress,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Radio,
    RadioGroup,
    Typography
} from "@material-ui/core";
import MuiPhoneNumber from "material-ui-phone-number";
import Pdf from "medis/src/assets/pdf/Договір публічної оферти_МеДіС.pdf";
import {useDispatch, useSelector} from "react-redux";
import Button from "@material-ui/core/Button";
import {getDoctor} from "@cabinet-packages/api";
import {AccessKey} from "@cabinet-packages/helpers";
import {setClient, setListOfPatients} from "@cabinet-packages/redux";
import moment from "moment";
import {
    checkPatient,
    patientAuth,
    registerChild,
    registerExisting,
    registerNew,
    setExistingPatients
} from "@cabinet-packages/api/api";
import {FormattedMessage} from "react-intl";

const NewPatientInOneStep = ({state, updateState, usePhone, isChangedStateSignUp, handleCheckboxState, uuid,
                                 disableConfirmSMS, handleValue, isDoctor, handleClose}) => {
    const cl = useStyles();
    const dispatch = useDispatch();
    const {takeId} = useSelector(state => state.assaysCatalog);
    const [phone, setPhone] = usePhone;
    const [checkboxState, setCheckboxState] = handleCheckboxState;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [stage, setStage] = useState(0);
    const [value, setValue] = handleValue;

    const handleChange = (event) => {
        setCheckboxState({ ...checkboxState, [event.target.name]: event.target.checked });
    };

    const handleSignUp = async (e) => {
        e.persist();
        e.stopPropagation();
        e.preventDefault();
        setLoading(true);
        setError(false);

        try {
            const result = await patientAuth('AUTHORISE', uuid, null, phone)

            if (result) {
                setStage(1);
            }
        } catch (e) {
            console.error(e);
            setError('Вибачте, сталася помилка при надсиланні номеру.');
        }

        setLoading(false);
    };

    const goBack = () => {
        setStage(0);
    };

    const handleConfirmSMS = async () => {
        setLoading(true);
        localStorage.setItem("activePatientPhone", phone.replace(/[[()\s]/g, ''));
        const fuckingPhone = phone;

        try {
            const result = await patientAuth('ACCEPT', uuid, value, phone)

            if ((result.data && result.data.token)) {
                AccessKey.set(result.data.token);

                if (result.data.exist) {
                    const patients = isDoctor ? await getDoctor() : await checkPatient('CHECK', uuid, null, phone, result.data.token);

                    dispatch(setListOfPatients(false, isDoctor, patients));

                    const isUserChooseMainPatient = patients.reduce((acu, cur) => {
                        if (cur.main) return cur.main;

                        return acu;
                    }, false);

                    if (isUserChooseMainPatient) {
                        const patients = isDoctor ? await getDoctor() : await checkPatient('CHECK', uuid, null, fuckingPhone, result.data.token);
                        const {lastname, firstname, fathername, birthday, sex, phone, email} = state;
                        const birthdayDate = typeof birthday === 'string' ? birthday : moment(birthday).format('YYYY-MM-DD');
                        const mainPatient = patients.find(patient => patient.main === true);
                        await registerChild(
                            mainPatient.id,
                            uuid,
                            lastname,
                            firstname,
                            fathername,
                            birthdayDate,
                            sex,
                            phone,
                            email
                        );

                        const patientsSecond = isDoctor ? await getDoctor() : await checkPatient('CHECK', uuid, null, fuckingPhone, result.data.token);

                        dispatch(setListOfPatients(true, isDoctor, patientsSecond));
                        dispatch(setClient(mainPatient));
                    } else {
                        const patients = isDoctor ? await getDoctor() : await checkPatient('CHECK', uuid, null, phone, result.data.token);

                        await setExistingPatients(
                            patients[0].id,
                            patients.map(patient => patient.id).filter(id => +id !== +patients[0].id),
                            phone.replace(/[[()\s]/g, ''),
                            checkboxState.checkedA,
                            checkboxState.checkedB,
                            false,
                            ''
                        );

                        dispatch(setListOfPatients(false, isDoctor, patients));
                    }
                } else { // not exist
                    const {lastname, firstname, fathername, birthday, sex, email} = state;
                    const birthdayDate = typeof birthday === 'string' ? birthday : moment(birthday).format('YYYY-MM-DD');
                    const result = await registerNew(uuid, lastname.trim(), firstname.trim(), fathername.trim(), birthdayDate, sex, phone.replace(/[[()\s]/g, ''), email);
                    AccessKey.set(result.token);

                    const patients = isDoctor ? await getDoctor() : await checkPatient('CHECK', uuid, null, phone, result.data.token);

                    await registerExisting(
                        patients[0].id,
                        patients.map(patient => patient.id).filter(id => +id !== +patients[0].id),
                        phone.replace(/[[()\s]/g, ''),
                        checkboxState.checkedA,
                        checkboxState.checkedB,
                        false,null, uuid);

                    dispatch(setListOfPatients(true, isDoctor, patients));
                }
            }
            setStage(2);
            handleClose();
        } catch (e) {
            console.error(e);
            setError('Вибачте, сталась помилка при реєстрації.')
        }

        setLoading(false);
    };

    return (<>
        {stage === 0 && <div className={cl.newPatientWrapper}>
            <div className={cl.newPatientFieldsGroup}>
                <FormattedMessage id="formatted.message.newpatient.name.text"
                                  defaultMessage="Ім'я">
                    {label => <TextField
                        className={cl.newPatientField}
                        value={state.firstname}
                        onChange={(event) => updateState('firstname', event.target.value)}
                        label={label}
                    />}
                </FormattedMessage>
                <FormattedMessage id="formatted.message.newpatient.lastname.text"
                                  defaultMessage="Прізвище">
                    {label =>
                        <TextField
                            className={cl.newPatientField}
                            value={state.lastname}
                            onChange={(event) => updateState('lastname', event.target.value)}
                            label={label}
                        />
                    }
                </FormattedMessage>
            </div>
            <div className={cl.newPatientFieldsGroup}>
                <FormattedMessage id="formatted.message.newpatient.fathername.text"
                                  defaultMessage="По батькові">
                    {label => <TextField
                        className={cl.newPatientField}
                        value={state.fathername}
                        onChange={(event) => updateState('fathername', event.target.value)}
                        label={label}
                    />}
                </FormattedMessage>
                <div className={cl.newPatientBirthdayGender}>
                    <div className={cl.newPatientBirthdayContainer}>
                        <p style={{height: '10px', color: 'rgba(0, 0, 0, 0.54)', fontSize: '12px'}}>Дата народження*</p>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={uaLocale}>
                            <KeyboardDatePicker
                                value={state.birthday}
                                onChange={(value) => {
                                    updateState('birthday', value)
                                }}
                                invalidDateMessage="Неправильний формат дати."
                                maxDateMessage="Дата народження не може бути в майбутньому."
                                format="yyyy-MM-dd"
                                disableFuture
                                // maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))}
                                cancelLabel="Назад"
                                okLabel="Ок"
                                openTo="year"
                            />
                        </MuiPickersUtilsProvider>
                    </div>
                    <FormControl component="fieldset" className={cl.newPatientFormComtrol}>
                        <FormLabel component="legend"
                                   style={{color: 'rgba(0, 0, 0, 0.54)', fontSize: '12px'}}>Стать</FormLabel>
                        <RadioGroup
                            row
                            value={state.sex}
                            onChange={(event) => updateState('sex', event.target.value)}
                            className={cl.genderGroup}>
                            <FormControlLabel
                                value="F"
                                control={<Radio color="primary"/>}
                                label="Ж"
                            />
                            <FormControlLabel
                                value="M"
                                control={<Radio color="primary"/>}
                                label="Ч"
                            />
                        </RadioGroup>
                    </FormControl>
                </div>
            </div>
            <div className={cl.newPatientFieldsGroup}>
                <FormattedMessage id="formatted.message.newpatient.email.text"
                                  defaultMessage="Емейл">
                    {label =>
                        <TextField
                            className={cl.newPatientField}
                            value={state.email}
                            onChange={(event) => updateState('email', event.target.value)}
                            label={`${label}*`}
                            type="email"
                        />
                    }
                </FormattedMessage>
                <FormattedMessage id="formatted.message.newpatient.phoneNumber.text"
                                  defaultMessage="Номер телефону">
                    {label =>
                        <MuiPhoneNumber
                            className={cl.newPatientField}
                            autoFocus={true}
                            defaultCountry='ua'
                            countryCodeEditable={false}
                            regions='europe'
                            label={`${label}*`}
                            value={phone}
                            onChange={(value) => setPhone(value)}
                        />
                    }
                </FormattedMessage>
            </div>
            <FormGroup className={cl.formCheckboxes}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checkboxState.checkedA}
                            onChange={handleChange}
                            name="checkedA"
                            color="primary"
                        />
                    }
                    label={<p>
                        Я погоджуюсь на використання <a href={takeId === 14 ? Pdf : undefined} target="_blank">
                        персональних даних.
                    </a>
                    </p>
                    }
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checkboxState.checkedB}
                            onChange={handleChange}
                            name="checkedB"
                            color="primary"
                        />
                    }
                    label="Я погоджуюсь на створення персонального кабінету."
                />
            </FormGroup>
            <div className={cl.newPatientActions}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSignUp}
                    className={cl.actionContainerButton}
                    disabled={isChangedStateSignUp || !checkboxState.checkedA || !checkboxState.checkedB || loading}
                >
                    <FormattedMessage id="formatted.message.newpatient.register.text"
                                      defaultMessage="Зареєструватись"/>
                </Button>
                {loading && <CircularProgress size={24} className={cl.buttonProgress}/>}
            </div>
            {error && <p className={cl.error}>{error}</p>}
        </div>}
        {stage === 1 && <div className={cl.codeEnterForm}>
            <h2 className={cl.confirmTitle}>
                <FormattedMessage id="formatted.message.newpatient.codeIsSent.text"
                                  defaultMessage="Код відправлено на номер"/><sup>*</sup></h2>
            <p className={cl.confirmPhone}>{phone}</p>
            <div className={cl.wrapperCode}>
                <FormattedMessage id="formatted.message.newpatient.enterCode.text"
                                  defaultMessage="Ведіть код">
                    {label =>
                        <TextField
                            label={label}
                            variant="outlined"
                            autoFocus={true}
                            value={value}
                            inputProps={{
                                maxLength: 4,
                            }}
                            onChange={(event) => setValue(event.target.value.replace(/[^0-9]/g, ''))}
                        />}
                </FormattedMessage>
            </div>
            <Typography variant="caption">* - <FormattedMessage id="formatted.message.newpatient.codeSentTo.text"
                                                                  defaultMessage="код надійде у Viber або SMS-повідомленням"/>.</Typography>
            <Button
                variant="contained"
                color="primary"
                className={cl.phoneConfirmationButton}
                onClick={handleConfirmSMS}
                disabled={disableConfirmSMS || loading}
            >
                <FormattedMessage id="formatted.message.newpatient.acceptCode.text"
                                  defaultMessage="підтвердити код"/>
                {loading && <CircularProgress size={24} className={cl.buttonProgress}/>}
            </Button>
            <Button
                variant="contained"
                color="secondary"
                className={cl.phoneConfirmationButton}
                onClick={goBack}
            >
                <FormattedMessage id="formatted.message.newpatient.retuenBack.text"
                                  defaultMessage="Повернутись назад"/>
            </Button>
        </div>}
        {stage === 2 && <div>
            <FormattedMessage id="formatted.message.newpatient.succefullCreated.text"
                              defaultMessage="новий пацієнт успішно створений"/>
        </div>}
    </>)
}

export default NewPatientInOneStep;
